module.exports = __webpack_public_path__ + "static/Ubuntu-884fc069f9036cdf9b5fc8070f5fcf99.png";